module.exports = __webpack_public_path__ + "static/media/excited-lively.02be8681.png";